<i18n>
{
	"en": {
		"title": "New driver",
		"name": "Name",
		"phone": "Phone",
		"email": "Mail",
		"save": "Save",
		"cancel": "Cancel"
	},
	"no": {
		"title": "Ny sjåfør",
		"name": "Navn",
		"phone": "Telefon",
		"email": "E-post",
		"save": "Lagre",
		"cancel": "Avbryt"
	}
}
</i18n>
<template>
	<t-dialog
		icon="new-person"
		:isShown="isShown"
		:title="$t('title')"
		:confirmLabel="$t('save')"
		:cancelLabel="$t('cancel')"
		iconType="bp"
		@close="onClose"
		@ok="onOk"
	>
		<t-form-group>
			<t-text-input v-model="name" :label="$t('name')"/>
			<t-text-input v-model="phoneNumber" type="tel" :label="$t('phone')"/>
			<t-text-input
				v-model="email"
				type="email"
				:label="$t('email')"
				:isInvalid="!emailValid"
				@input="onEmailChange"
			/>
		</t-form-group>
	</t-dialog>
</template>

<script>
import { mapActions } from './store/drivers.store';
export default {
	props: {
		isShown: Boolean,
	},
	data() {
		return {
			name: '',
			phoneNumber: '',
			email: '',
			emailValid: true,
			emailValidatorDebounce: undefined,
			emailRegEx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
		};
	},
	methods: {
		...mapActions(['createDriver']),
		onEmailChange() {
			if (this.emailValidatorDebounce !== undefined) {
				clearTimeout(this.emailValidatorDebounce);
			}
			this.emailValidatorDebounce = setTimeout(this.validateEmail, 500);
		},
		validateEmail() {
			if (this.email === '') {
				this.emailValid = true;
				return;
			}
			
			this.emailValid = this.emailRegEx.test(this.email);
		},
		onClose() {
			this.$emit('close');
		},
		async onOk() {
			let newDriver = await this.createDriver({ name: this.name, phoneNumber: this.phoneNumber, email: this.email });
			this.$emit('ok', newDriver);
		},
	}
};
</script>

<style>

</style>